import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CopyButton from './CopyButton';

const TransactionIdColumn = ({
  value,
  enableNavigation = true,
  enableCopy = true,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (enableNavigation && value) {
      navigate(`/admin/transfers/${value}${location.search}`);
    }
  };

  const content =
    enableNavigation && value ? (
      <Link
        component='button'
        variant='body2'
        onClick={handleClick}
        sx={{
          fontFamily: 'monospace',
          textDecoration: 'underline',
          cursor: 'pointer',
          color: 'primary.main',
          '&:hover': {
            color: 'primary.dark',
          },
        }}>
        {value}
      </Link>
    ) : (
      <Typography variant='body2' sx={{ fontFamily: 'monospace' }}>
        {value || '–'}
      </Typography>
    );

  if (enableCopy && value && value !== '–') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {content}
        <CopyButton text={value} />
      </Box>
    );
  }

  return content;
};

export default TransactionIdColumn;
